import { render, staticRenderFns } from "./InfoTopRight.vue?vue&type=template&id=49125572&scoped=true&"
import script from "./InfoTopRight.vue?vue&type=script&lang=js&"
export * from "./InfoTopRight.vue?vue&type=script&lang=js&"
import style0 from "./InfoTopRight.vue?vue&type=style&index=0&id=49125572&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49125572",
  null
  
)

export default component.exports